/**
* @file breadcrumb
* @author Ice(chenzhouji@baidu.com)
*/
import React, {FunctionComponent, ReactDOM, Fragment} from 'react';
import _ from 'lodash';

type BreadcrumbItem = {
    name: string
    path?: string
};

type BreadcrumbProps = {
    items: BreadcrumbItem[]
    separator?: ReactDOM | string
};

const Breadcrumb: FunctionComponent<BreadcrumbProps> = ({
    items,
    separator = '>'
}) => {

    return (
        <ul className="breadcrumb">
        {_.map(items, (item, index, all) => {
            const linkEl = (
                <li className="breadcrumb__item">
                {item.path
                    ? <a href={item.path}>{item.name}</a>
                    : <span>{item.name}</span>
                }
                </li>
            );
            const separatorEl = all.length - 1 !== index
                ? <li className="breadcrumb__separator">{separator}</li>
                : null;

            return (
                <Fragment key={item.name}>
                    {linkEl}
                    {separatorEl}
                </Fragment>
            );
        })}
        </ul>
    );
};

export default Breadcrumb;
